import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StatusconfigurationDataService } from "../data-services/status-configuration-data.service";


@Injectable({
  providedIn: 'root'
})
export class StatusconfigurationService {

  constructor(
    private http: HttpClient,
    private statusconfigurationDataService: StatusconfigurationDataService
  ) { }

   async  getStatusList(language: number) : Promise<any>{
    return  this.statusconfigurationDataService.getStatusList(language);
  }

  async saveStatusConfiguration(mapData: any) : Promise<Observable<any>>{
    return this.statusconfigurationDataService.saveStatusConfiguration(mapData);

  }


}
